var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDebitCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 28,
    viewBox: "0 0 42 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5073 4.22117C22.8698 4.22117 25.0414 5.06381 26.7278 6.47087H32.9482V0H8.06641V6.47087H14.2869C15.9812 5.07176 18.1448 4.22117 20.5073 4.22117Z",
    fill: "#00adef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5073 23.6794C18.1448 23.6794 15.9812 22.8367 14.2869 21.4297H8.06641V27.9006H32.9482V21.4297H26.7278C25.0414 22.8367 22.8698 23.6794 20.5073 23.6794Z",
    fill: "#00adef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8066 6.47087H41.0135V3.84754C41.0135 1.72503 39.2873 0 37.1634 0H33.8066V6.47087Z",
    fill: "#00adef"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8066 21.4297V27.9006H37.1634C39.2873 27.9006 41.0135 26.1755 41.0135 24.053V21.4297H33.8066Z",
    fill: "#00adef"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5652 22.5829C27.3356 21.4516 30.2851 16.6697 29.153 11.9024C28.021 7.135 23.2361 4.1874 18.4657 5.31873C13.6953 6.45006 10.7458 11.2319 11.8779 15.9993C13.0099 20.7666 17.7948 23.7142 22.5652 22.5829Z",
    fill: "#00adef"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00795017 20.5719H13.3875C11.7648 18.831 10.7704 16.5098 10.7704 13.95C10.7704 11.3903 11.7648 9.06906 13.3795 7.32812H0V20.5719H0.00795017Z",
    fill: "#00adef"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21463 6.47087V0H3.85781C1.72599 0 0.0078125 1.72503 0.0078125 3.84754V6.47087H7.21463Z",
    fill: "#00adef"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21463 21.4297H0.0078125V24.053C0.0078125 26.1755 1.73395 27.9006 3.85781 27.9006H7.21463V21.4297Z",
    fill: "#00adef"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0065 7.32812H27.627C29.2497 9.06906 30.244 11.3903 30.244 13.95C30.244 16.5098 29.2497 18.831 27.627 20.5719H41.0065V7.32812Z",
    fill: "#00adef"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitCard);
export default __webpack_public_path__ + "static/media/DebitCard.3172209434c6fabe8f41b086e02d1e45.svg";
export { ForwardRef as ReactComponent };